import React from 'react';
import PropTypes from 'prop-types';
import Block from './Block';

export default class BlockWrapper extends React.Component {
    static propTypes = {
        blocks: PropTypes.array,
        useNarrowImage: PropTypes.bool
    };

    render() {
        const blocks = this.props.blocks || [];
        const useNarrowImage = this.props.useNarrowImage || false;
        return (
            <div className={`blocks-grid ${useNarrowImage ? 'narrow-grid' : 'square-grid'}`}>
                {blocks.map((block, index) => (
                    <Block key={block.url} block={block} useNarrowImage={useNarrowImage} />
                ))}
            </div>
        );
    }
}
